import _isEmpty from 'lodash/isEmpty';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';

export const getCookieOrLocalStorageData = (reqHeaders = {}, key) => {
    if (__SERVER__) {
        const reqCookies = reqHeaders?.cookies;
        return !_isEmpty(reqCookies) && reqCookies[key];
    }
    const localStorageValue = LocalStorage.getData(key);
    return _isEmpty(localStorageValue) ? Cookies.load(key) : localStorageValue;
};

export const toCapitalize = (s) => {
    if (!s) {
        return '';
    }
    const oldStr = s.split(' ');
    const newStr = oldStr.map((i) => {
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(i)) {
            const str = i.substring(1, 0).toUpperCase() + i.substring(1, i.length).toLowerCase();
            return str;
        }
        return i;
    });
    return newStr.join(' ');
};

export function getDeviceInfo(isNative = false, enableADIBrowserDeviceTransactionId = true) {
    const deviceInfo = {};
    let failedToFetchNativeDeviceTransactionId = false;
    if (!__SERVER__) {
        if (isNative) {
            if (Cookies.load('DP_APP_DEVICE_TRANSACTION_ID')) {
                deviceInfo.deviceTransactionId = Cookies.load('DP_APP_DEVICE_TRANSACTION_ID');
            } else if (enableADIBrowserDeviceTransactionId && window?._bcn?.dvc) {
                deviceInfo.deviceTransactionId = window._bcn.dvc.getTID();
                failedToFetchNativeDeviceTransactionId = true;
            }
        } else {
            if (window?._bcn?.dvc) {
                deviceInfo.deviceTransactionId = window._bcn.dvc.getTID();
            }
            if (window?._bcn) {
                deviceInfo.ubaToken = window._bcn.getToken();
                deviceInfo.ubaSessionId = window._bcn.getUbaSessionId();
                deviceInfo.ubaPageId = window._bcn.getPageId();
                deviceInfo.ubaEvents = window._bcn.getEvents();
            }
        }
    }
    return { deviceInfo, failedToFetchNativeDeviceTransactionId };
}

export function getAccertifyStatus(status) {
    return {
        isApproved: status === 'A',
        isDenied: status === 'R',
        isChallenge: status === 'C',
        isUnknown: status === 'U',
    };
}

/** Webvitals helper method */
export function getNumbersWithInterval(interval, end) {
    const numbers = [];
    for (let i = 0; i <= end; i += interval) {
        numbers.push(Math.round(i * 100) / 100);
    }
    return numbers;
}

function getWebvitalRange(num, intervals) {
    const intervalsLength = intervals?.length;
    if (num > intervals[intervalsLength - 1]) return `above${intervals[intervalsLength - 1]}`;
    for (let i = 0; i < intervalsLength; i++) {
        if (num >= intervals[i] && num <= intervals[i + 1]) {
            return intervals[i + 1];
        }
    }
}

export function constructWebVitalMetric(data, intervals) {
    const { name = '', value = '', rating = '' } = data;
    if (name === 'INP') return { name, value, rating };

    const metricToConverted = ['FCP', 'LCP', 'TTFB'];
    const convertedValue = metricToConverted.includes(name) ? value / 1000 : value;
    const result = { name, value: Math.round(convertedValue * 100) / 100, rating };
    const range = value && name ? getWebvitalRange(result.value, intervals[name]) : 0;
    if (range) result.interval = range;
    return result;
}

export default {
    toCapitalize,
    getCookieOrLocalStorageData,
    getDeviceInfo,
    getAccertifyStatus,
    getNumbersWithInterval,
    constructWebVitalMetric,
};
